
import Btn from '../elements/Btn';
import Hero from '../elements/Hero'
import Title from '../elements/Title'
import movingDetail from '../img/movingDetail.png';
import AdditionalServices from "../elements/AdditionalServices";
import HappyCustomers from '../elements/HappyCustomers';
import Newsletter from '../elements/Newsletter'; 
import Footer from '../elements/Footer';
import FreeQuote from '../elements/FreeQuote';
import QuickServices from '../elements/QuickServices';
import packvideo from '../img/packvideo.png';
import movie from '../video/movie.mp4';
import localmoveIcon from '../img/icon/localmoving.png';
import longdistance from '../img/icon/longdistance.png';
import officemoving from '../img/icon/officemoving.png';
import localmove from '../img/services/localmove.png';
import longdistanceimg from '../img/services/longdistance.png';
import office from '../img/services/office.png';
import user from '../img/testimonial.png';
export default function Moving() { 
    const service = [
        {
            title: "Moving, Packing &Unpacking Services", 
            des: "Sometimes packing can feel like a real chore, and even be a big undertaking for your family. Whether it's a single item or your entire home, our team is happy to offer complete packing and unpacking services."
        },
        {
            title: "All Sizes Boxes Moving Supplies",
            des: "From boxes of all sizes to tape to keep those boxes secure, to packing peanuts and bubble wrap, we have the high-quality moving supplies you need to protect all your belongings."
        },
        { 
            title: "Comprehensive Moving Checklist",
            des: "How many steps are there to moving? The more you think about it, the more steps there seem to be. When you hire the HUNKS, you'll also receive a comprehensive moving checklist to help with your big move."
        },
        {
            title: "Comprehensive Moving Checklist",
            des: "How many steps are there to moving? The more you think about it, the more steps there seem to be. When you hire the HUNKS, you'll also receive a comprehensive moving checklist to help with your big move."
        }
    ];

    const customers = [
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        },
        {
        title: "Excellent service, on time. Careful, courteous!",
        description: "Saul, Adrian, and Rodolfo were great! They were very professional, good with communication, and efficient. We will be using Exquisite Moves again in the future when we move again!",
        user: "Dianne Russell",
        userPost: "Exquisitemoves Director",
        useravatar: user,
        rating: "4.9"
        }, 

    ]


    return <>
        <Hero bg={movingDetail} >
            <div className='pt-3 pt-sm-4 pt-lg-5 bannerTri vvv' >
                <div className='row' >
                    <div className='col-md-12 pb-5 mt-3' >
                        <div className='banner_content py-0 pt-4' >
                            <Title mainClass="text-center"
                                titleclass="lg text-white mb-2"
                                desclass="text-center mt-3 mb-2"
                                title={<>Stress-Free Moving & <br></br>
                                    Junk Removal, We Move People Forward!</>}
                                des="ExquisiteMoves is the nation’s leading full-service moving company, offering customers comprehensive home and business relocation, packing and unpacking, and junk removal services."
                            />

                            <div className='movingTypes' >
                                <ul>
                                    <li>
                                        <input type="radio" id='moving' defaultChecked name='movingtypes' />
                                        <label htmlFor="moving">Local Moving</label>
                                    </li>
                                    <li>
                                        <input type="radio" id='longdistance' name='movingtypes' />
                                        <label htmlFor="longdistance">Long Distance Moving</label>
                                    </li>
                                    <li>
                                        <input id='office' type="radio" name='movingtypes' />
                                        <label htmlFor="office">Office & Business Moving</label>
                                    </li>
                                </ul>
                            </div>

                            <Btn class="mb-4 m-auto d-table"
                                arrow={true}
                                wave={true} 
                                href="#"
                            >Book now Donation Pickup & Delivery Service</Btn>
                        </div>
                    </div>
                </div>
            </div>
        </Hero>
        <div className='packingVideo py-5' >
            <div className='container' >
                <Title mainClass="mb-3"
                    subheading="Service: moving & PACKING"
                    subclass="mb-1 mb-md-2 border-none text-center text-uppercase"
                    titleclass="md heading text-dark text-center  mb-3 mt-0 mt-lg-3"
                    desclass="mb-0 text-center w-50 m-auto d-table"
                    title={<>At Exquisite Moves®, We know Moving can be Difficult <br></br> & Stressful – but it doesn’t have to be!</>}
                    des="Our professional moving team is dedicated to providing the highest quality service for every move, no matter how big or small."
                />
                <div className='pcVid' >
                    <video poster={packvideo} controls >
                        <source src={movie} type="video/mp4" />
                        <source src={movie} type="video/ogg" />
                    </video>
                </div>
            </div>
        </div>

        {/* high quality */}
        <div className='highQuality pt-0 pt-md-5 pb-5 ' >
            <div className='container' >
                <Title mainClass="mb-3"
                    titleclass="md heading text-center text-dark text-start mb-1 mt-0 mt-lg-3"
                    desclass="mb-0 text-center w-70 m-auto d-table"
                    title={<>Highest Quality Moving Service</>}
                    des={<>Our Exquisite Moves team undergo extensive move training to wrap your items correctly and securely to prevent any dings, scratches, cracks, and breaks. We’ll treat your items like our own to ensure that your items arrive at your new home in exactly the same condition they were removed. We are fully licensed, bonded, and insured for your protection and peace of mind. <a className='d-block w-100' href='learnmore' >Learn more about the types of moving services we offer.</a></>}
                />

                <div className='row featuresBox' >
                    <div className='col-md-4 mt-4' >
                        <div className='highQbox text-center' >
                            <img src={localmoveIcon} className="img-fluid m-auto d-table mb-4" alt="service" />
                            <h2>Local Moving</h2>
                            <p>When it comes to residential local moving, there’s no such thing as a “one size fits all” solution.</p>
                            <a href="#" >Learn More</a>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4' >
                        <div className='highQbox text-center' >
                            <img src={longdistance} className="img-fluid m-auto d-table mb-4" alt="service" />
                            <h2>Long  Distance Moving</h2>
                            <p>As a full-service long distance moving company, we know what it takes to make a successful long-distance transition.</p>
                            <a href="#" >Learn More</a>
                        </div>
                    </div>
                    <div className='col-md-4 mt-4' >
                        <div className='highQbox text-center' >
                            <img src={officemoving} className="img-fluid m-auto d-table mb-4" alt="service" />
                            <h2>Office & Business Moving</h2>
                            <p>Professional Corporate Relocation Solutions. Our Team of Business moving will go beyond to make sure we exceed your Business expectations.</p>
                            <a href="#" >Learn More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* serices details */}
        <div className='serviceDt' >
            <div className='container' >
                <div className="serviceSec pt-5 pb-5" >
                    <div className="row align-items-center " >
                        <div className="col-lg-6 pb-4 pb-lg-0" >
                            <div className='servIc mb-2 mb-md-3' >
                                <img src={localmoveIcon} className="img-fluid" alt="servive icon" />
                            </div>
                            <Title mainClass="mb-3"
                                subheading="local moving solutions you can count on !"
                                subclass="order-2 mb-2 border-none text-start text-uppercase"
                                titleclass="order-1 lg heading text-dark text-start  mb-1 mt-0 mt-lg-3"
                                desclass="mb-3 order-3"
                                title={<>Local Moving</>}
                                des="Moving to a new home? Exquisite Moves® offers full-service local movers dedicated to providing you with dependable five-star packing and moving services. Our 15+ years of experience and commitment to the very best service in the industry ensures that you and your belongings will be completely taken care of."
                            />
                            <Btn class="mt-2 mt-md-4"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Learn More</Btn>
                        </div>
                        <div className="col-lg-6 ps-lg-5" >
                            <img src={localmove} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div>
                <div className="serviceSec pt-5 pb-5" >
                    <div className="row align-items-center flex-lg-row-reverse " >
                        <div className="col-lg-6  pb-4 pb-lg-0" >
                            <div className='servIc mb-2 mb-md-3' >
                                <img src={longdistance} className="img-fluid" alt="servive icon" />
                            </div>
                            <Title mainClass="mb-3"
                                subheading="Long Distance Moving Services By Trusted Professionals"
                                subclass="order-2 mb-2 border-none text-start text-uppercase"
                                titleclass="order-1 lg heading text-dark text-start  mb-1 mt-0 mt-lg-3"
                                desclass="mb-3 order-3"
                                title={<>Long  Distance Moving</>}
                                des="A big move takes time, money, and the right team. Whether you're moving to a new state or across the country, Exquisite Moves® is proud to offer full-services for your long-distance move. With our innovative trucking network and team of trained professionals, you'll be amazed at how much time and money you'll save!"
                            />
                            <Btn class="mt-2 mt-md-4"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Learn More</Btn>
                        </div>
                        <div className="col-lg-6 pe-lg-5" >
                            <img src={longdistanceimg} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div>
                <div className="serviceSec pt-5 pb-5" >
                    <div className="row align-items-center " >
                        <div className="col-lg-6  pb-4 pb-lg-0" >
                            <div className='servIc mb-2 mb-md-3' >
                                <img src={officemoving} className="img-fluid" alt="servive icon" />
                            </div>
                            <Title mainClass="mb-3"
                                subheading="Professional Corporate Relocation Solutions"
                                subclass="order-2 mb-2 border-none text-start text-uppercase"
                                titleclass="order-1 lg heading text-dark text-start  mb-1 mt-0 mt-lg-3"
                                desclass="mb-3 order-3"
                                title={<>Office & Business Moving</>}
                                des="Exquisite Moves® is proud to offer full-service office moving for companies of all sizes. Our team of moving professionals will go above and beyond to make sure we exceed your expectations. Whether you need to move your entire business, a single division, or relocate offices, you can count on our expert movers to make it a smooth transition."
                            />  
                            <Btn class="mt-2 mt-md-4"
                                arrow={true}
                                wave={true}
                                wavedark={true}
                                href="#"
                            >Learn More</Btn> 
                        </div>
                        <div className="col-lg-6 ps-lg-5" >
                            <img src={office} className="img-fluid" alt="services" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <AdditionalServices 
        title="Additional Services"
        des="Whether You’re Looking For A Little Help Loading And Unloading Your Moving Truck, Or You Want A Full-Service Move Including Packing, Unpacking, Arranging, And Everything In Between, Our Team Is Ready To Help You. We Promise To Provide 100% Satisfaction With Every Project."
        data={service} />
        <HappyCustomers customers={customers} />
        <QuickServices />
        <FreeQuote />
        <Newsletter />
        <Footer />
    </>
}